import { render, staticRenderFns } from "./HelpdeskCategoryDropdown.vue?vue&type=template&id=60b3afe2"
import script from "./HelpdeskCategoryDropdown.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskCategoryDropdown.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports